import React, { forwardRef } from 'react';
import cn from 'classnames';

import styles from './input-row.module.scss';

const InputRow = forwardRef(
  (
    {
      children,
      className,
      ...props
    }: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <div ref={ref} className={cn(styles.container, className)} {...props}>
        {children}
      </div>
    );
  },
);

InputRow.displayName = 'InputRow';

export default InputRow;
